<template>
  <div class="license">
    <span style="display: inline-block;">© 2021 上海至信信息科技有限公司. All Rights Reserved.</span>
    <br>
    <span style="display: inline-block;">沪ICP备2021009252</span>
  </div>
</template>

<script>
export default {
  name: "License"
}
</script>

<style scoped>
  .license {
    text-align: center;
    font-size: 12px;
    font-weight: normal;
    padding-top: 5px;
    color: #808080;
  }
</style>



// WEBPACK FOOTER //
// src/components/License.vue